import posthog from "posthog-js";

const projectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

export const isPostHogEnabled = Boolean(projectToken && host);

if (!projectToken) {
  if (import.meta.env.DEV) {
    console.warn(
      "VITE_PUBLIC_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, this causes events to be silently missed. This warning stops appearing once VITE_PUBLIC_POSTHOG_PROJECT_TOKEN is configured"
    );
  }
} else if (!host) {
  if (import.meta.env.DEV) {
    console.warn(
      "VITE_PUBLIC_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This warning stops appearing once VITE_PUBLIC_POSTHOG_HOST is configured"
    );
  }
} else {
  posthog.init(projectToken, {
    api_host: host,
    defaults: "2026-01-30",
    // Kiosk browser window never closes, so PostHog's own inactivity-based
    // session and autocapture/pageview would not match the app's own
    // session concept (see src/services/analytics). Only explicit capture()
    // calls from src/services/analytics should send events.
    autocapture: false,
    capture_pageview: false,
    disable_session_recording: true,
    // Memory-only: every visitor is anonymous and transient (docs/posthog-usage.md),
    // so no distinct ID should persist across golfers sharing this kiosk.
    persistence: "memory",
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
    logs: {
      serviceName: "golf-on-course-web",
      environment: import.meta.env.VITE_DEPLOY_ENV || import.meta.env.MODE,
      serviceVersion:
        import.meta.env.VITE_FULL_VERSION || import.meta.env.VITE_APP_VERSION,
    },
  });

  // Super property: persists on every event PostHog captures, not just logs.
  posthog.register({
    appVersion:
      import.meta.env.VITE_FULL_VERSION || import.meta.env.VITE_APP_VERSION,
  });
}

export default posthog;
